import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Modal, withStyles } from '@material-ui/core';
import Button from 'react-bootstrap/Button';
import AvatarCircle from '../AvatarCircle';
import { commonStyles, COLORS } from '../../styles/styles';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import AlertAnnouncement from '../../assets/alertAnnouncement.svg'
import SystemAnnouncement from '../../assets/systemAnnouncement.svg'
import { updateAnnouncementStatusRequest, messageStatusAction } from '../../redux/reducers/message';
import { resetSelectionMessage, selectMessage } from '../../redux/reducers/teamMembersFull';


class Announcements extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    const { showAlert, toggleShowAlert } = this.props;
    if (typeof toggleShowAlert === 'function') {
      toggleShowAlert(!showAlert);
    }
  }
  render() {
    const {classes, showAlert} = this.props
    return (
      this.props.loginReducer.user ? <MDBContainer>
        <MDBModal isOpen={showAlert} toggle={this.toggle} centered   >
          <MDBModalHeader className="m-1 " style={{color:'black'}} toggle={this.toggle}>
            <div className="copy">
              <b>{"Hi "+this.props.loginReducer.user.firstName},</b><br />
            </div>
            <div className="popinsCopy" style={{fontSize: 13}}>
              Please click on each notification to accept and enter the platform
            </div>
          </MDBModalHeader>
          <MDBModalBody style={{padding: '0px 10px 10px'}}>
          
        {
          this.props.newAnnouncements.map(
            content => {
              switch (content.type) {
                case 'site':
                  return <div className="dialogBlueBg">
                  <div className="dialogIconBg">
                    <img src={SystemAnnouncement} alt="addCodeImage" className={classes.image} />
                 </div> 
                 <div className="dialogCopy">
                   {content.message}
                 </div>
                 <DialogActions className={classes.dialogActions}>
                   <MDBBtn className="btn-sm btn-green" onClick={()=>  this.props.handleMessageUpdate(content.messageId)} >
                     ACCEPT
                   </MDBBtn>
                   {/* <Button className={classes.doneBtn} onClick={()=>  handleOk()} color="primary">
                     X
                   </Button> */}
                 </DialogActions>
                 <div className={classes.clearBoth}></div>
               </div>
                  break;
              
                default:
                    return <div className={classes.dialogPinkBg}>
                    <div className="dialogIconBg">
                    <img src={AlertAnnouncement} alt="addCodeImage" className={classes.image} />
                   </div> 
                   <div className="dialogCopy">
                     {content.message}
                   </div>
                   <DialogActions className={classes.dialogActions}>
                     <MDBBtn className="btn-sm" onClick={()=>  this.props.handleMessageUpdate(content.messageId)} color="primary">
                       ACCEPT
                     </MDBBtn>
                     {/* <Button className={classes.doneBtn} onClick={()=>  handleOk()} color="primary">
                       X
                     </Button> */}
                   </DialogActions>
                   <div className={classes.clearBoth}></div>
                 </div>
                  break;
              }
             
              
            }
          )}
        </MDBModalBody> 
        </MDBModal>
        </MDBContainer>: null
    );
  }
}

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});
const mapStateToProps = state => ({
    announcements: state.announcementsReducer.announcements,
    loginReducer: state.loginReducer
  });
  
const mapDispatchToProps = dispatch => ({
  updateAnnouncementStatusRequest: messageId => dispatch(updateAnnouncementStatusRequest(messageId)),
  resetSelectionMessage: messageId => dispatch(resetSelectionMessage(messageId)),
  messageStatusAction: messageId => dispatch(messageStatusAction(messageId)),

  selectMessage: messageId => dispatch(selectMessage(messageId)),

});
export default compose(
    withRouter,
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    withState('showAlert', 'toggleShowAlert', false),
    withState('newAnnouncements','setAnnouncements', []),
    withHandlers({
      handleMessageUpdate: props => (messageId) => {
        props.resetSelectionMessage();
        props.selectMessage(messageId)
        props.messageStatusAction('read');
        props.updateAnnouncementStatusRequest(messageId)
      },
    }),
    lifecycle({
      componentWillMount(){

      },
      componentWillReceiveProps(nextProps) {
      
        if(nextProps.announcements!=this.props.announcements){
          var ann=[]
          for (let index = 0; index < nextProps.announcements.length; index++) {
            const element = nextProps.announcements[index];
            if(element.status=='new'){
              ann.push(element)
            }
            
          }
          nextProps.setAnnouncements(ann);
          if(ann.length>0){
            nextProps.toggleShowAlert(true);
          }else{
            nextProps.toggleShowAlert(false);
          }
        }
    },
  }),
    withStyles(styles), 
)(Announcements)
